import React from "react";
import { MessageCircle, Instagram, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="mx-auto max-w-4xl px-6 py-16" data-testid="contact-root">
      <div className="text-center">
        <div className="eyebrow">Fale conosco</div>
        <h1 className="mt-2 font-display text-5xl text-[#0D1B2A]">Vamos <em className="font-script text-[#D4AF37] not-italic">conversar</em></h1>
        <p className="mt-4 text-[#3A4A5F]">Respondemos em minutos pelo WhatsApp.</p>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-5">
        <a href="https://wa.me/5542984285953" target="_blank" rel="noreferrer" data-testid="contact-karine" className="bg-white rounded-2xl p-6 border border-[#0D1B2A]/5 lift flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-[#25D366]/15 flex items-center justify-center"><MessageCircle size={22} className="text-[#25D366]" /></div>
          <div>
            <div className="font-display text-xl text-[#0D1B2A]">Karine</div>
            <div className="text-sm text-[#6B7280]">(42) 98428-5953</div>
          </div>
        </a>
        <a href="https://wa.me/5542984210960" target="_blank" rel="noreferrer" data-testid="contact-ayran" className="bg-white rounded-2xl p-6 border border-[#0D1B2A]/5 lift flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-[#25D366]/15 flex items-center justify-center"><MessageCircle size={22} className="text-[#25D366]" /></div>
          <div>
            <div className="font-display text-xl text-[#0D1B2A]">Ayran</div>
            <div className="text-sm text-[#6B7280]">(42) 98421-0960</div>
          </div>
        </a>
        <a href="https://instagram.com/eternizaimas" target="_blank" rel="noreferrer" data-testid="contact-instagram" className="bg-white rounded-2xl p-6 border border-[#0D1B2A]/5 lift flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-[#F7F2E7] flex items-center justify-center"><Instagram size={22} className="text-[#0D1B2A]" /></div>
          <div>
            <div className="font-display text-xl text-[#0D1B2A]">Instagram</div>
            <div className="text-sm text-[#6B7280]">@eternizaimas</div>
          </div>
        </a>
        <div className="bg-white rounded-2xl p-6 border border-[#0D1B2A]/5 flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-[#F7F2E7] flex items-center justify-center"><MapPin size={22} className="text-[#0D1B2A]" /></div>
          <div>
            <div className="font-display text-xl text-[#0D1B2A]">Envios</div>
            <div className="text-sm text-[#6B7280]">Para todo o Brasil</div>
          </div>
        </div>
      </div>
    </div>
  );
}
